import { createAction, props } from '@ngrx/store';
import { IBusinessPlanDetail, IBusinessPlanDetailResponse } from './business-plant-detail.models';

export const loadBusinessPlantDetail = createAction('[BusinessPlantDetail] Load', props<IBusinessPlanDetail>());

export const loadBusinessPlantDetailSuccess = createAction(
  '[BusinessPlantDetail] Load Success',
  props<{ BusinessPlanGuid: string; detail: IBusinessPlanDetailResponse }>(),
);

export const loadBusinessPlantDetailFailure = createAction(
  '[BusinessPlantDetail] Load Failure',
  props<{ error: string }>(),
);

export const resetBusinessPlantDetail = createAction('[BusinessPlantDetail] Reset');
export const refreshBusinessPlantDetail = createAction('[BusinessPlantDetail] Refresh');
